import React, { useMemo } from 'react'
import { buildNormalized, Divider, MetricSection, Wapper } from '../Sales/EnquiryPaymentOrder'
import { displayAmount } from '@utils'
import { MB_ROLES } from '@constants'

const EnquiryRevenue2 = ({
	dashboardType,
	Quoted,
	TotalEnquiries,
	OrganicQuotesConverted,
	NewSuppliersOnboarded,
	OrderConvert,
	OpenOrderBook,
	Serviced,
	BilledInvoiced,
	SupplyMargin,
	AdvtoSupplier,
	QuotedWeight,
	OrderConverted,
	ServicedWeight,
	OpenOrderBooks,
	EnquiryWeight,
	DebitNote,
	AverageQuoteCount,
}) => {
	const _quotedWeight = QuotedWeight?.find((item) => item.unit_type === 'WEIGHT')
	const _enquiryWeight = EnquiryWeight?.find((item) => item.unit_type === 'WEIGHT')

	const isSupplyAdmin = dashboardType === MB_ROLES.SUPPLY

	const { enquiryWeights, quotedWeights, orderConverted, openOrderBooks, servicedWeight } = useMemo(
		() => ({
			enquiryWeights: buildNormalized(EnquiryWeight),
			quotedWeights: buildNormalized(QuotedWeight),
			orderConverted: buildNormalized(OrderConverted),
			openOrderBooks: buildNormalized(OpenOrderBooks),
			servicedWeight: buildNormalized(ServicedWeight),
		}),
		[EnquiryWeight, QuotedWeight, OrderConverted, OpenOrderBooks, ServicedWeight]
	)

	const enquiryContentData = [
		{
			name: 'Quoted vs Total enquiries',
			value: `${Quoted}/${TotalEnquiries}` ?? '-',
			unit: '',
			hoverItems: [],
		},
		{
			name: 'Organic Quotes ',
			value: OrganicQuotesConverted ?? '-',
			unit: '',
			hoverItems: [],
		},
		{
			name: 'New Suppliers Onboarded',
			value: NewSuppliersOnboarded ?? '-',
			unit: '',
			hoverItems: '',
		},
	]

	const _enquiryDemo = [
		{
			name: 'Enquiry Weight',
			value: _enquiryWeight?.total_value ?? '-',
			unit: 'MT',
			hoverItems: enquiryWeights || [],
		},
		{
			name: 'Quoted Weight',
			value: _quotedWeight?.total_value ?? '-',
			unit: 'MT',
			hoverItems: quotedWeights || [],
		},
		{
			name: 'Average No. Of Quotes/Enquiry',
			value: AverageQuoteCount ?? '-',
			unit: '',
			hoverItems: '',
		},
	]

	const OrdersData = [
		{ name: 'Order Converted', value: OrderConvert, unit: 'MT', hoverItems: orderConverted || [] },
		{ name: 'Open Order book', value: OpenOrderBook, unit: 'MT', hoverItems: openOrderBooks || [] },
		{ name: 'Serviced', value: Serviced, unit: 'MT', hoverItems: servicedWeight || [] },
	]

	const RevenueData = [
		{
			name: `${isSupplyAdmin ? 'Billed' : 'Billed/Debit Note'}`,
			value: `${
				isSupplyAdmin ? `${displayAmount(BilledInvoiced - DebitNote)}` : `${displayAmount(BilledInvoiced)}/${displayAmount(DebitNote)}`
			}`,
			unit: 'Cr',
			hoverItems: [],
		},
		{ name: 'Supply Margin', value: displayAmount(SupplyMargin), unit: '', hoverItems: [] },
		{ name: 'Adv To Supplier', value: displayAmount(AdvtoSupplier), unit: 'Cr', hoverItems: [] },
	]

	return (
		<Wapper>
			<MetricSection title='Quotes' items={enquiryContentData ?? []} />
			<Divider />
			<MetricSection title='Enquiry' items={_enquiryDemo ?? []} />
			<Divider />
			<MetricSection title='Orders' items={OrdersData ?? []} />
			<Divider />
			<MetricSection title='Revenue vs Billing' items={RevenueData ?? []} />
		</Wapper>
	)
}

export default EnquiryRevenue2
